import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const propTypes = {
  page: PropTypes.object.isRequired,
  PostType: PropTypes.func.isRequired,
};

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    // [theme.breakpoints.up('md')]: {
    //   maxWidth: 399,
    //   margin: theme.spacing.unit * 2,
    // },
    // [theme.breakpoints.up('lg')]: {
    //   backgroundColor: 'blue',
    // },
  },
});

const GridItem = (props) => {
  const { classes, PostType, page } = props;
  return (
    <div className={classes.root} >
      <PostType {...page} />
    </div>
  );
};

GridItem.propTypes = propTypes;

export default withStyles(styles, { name: 'styledGridItem' })(GridItem);



// WEBPACK FOOTER //
// ./src/components/grid-item/grid-item.jsx